import { lazy, type ComponentType } from "react";

const RELOAD_KEY = "nn-chunk-reload";

/**
 * React.lazy that survives a stale deploy: if a page chunk can't be loaded
 * (the web app was updated while it was open), reload once to pick up the
 * new build instead of crashing.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function lazyWithRetry<T extends ComponentType<any>>(
  factory: () => Promise<{ default: T }>,
) {
  return lazy(async () => {
    try {
      const module = await factory();
      try {
        sessionStorage.removeItem(RELOAD_KEY);
      } catch {
        // ignore
      }
      return module;
    } catch (error) {
      let alreadyReloaded = false;
      try {
        alreadyReloaded = sessionStorage.getItem(RELOAD_KEY) === "1";
        if (!alreadyReloaded) sessionStorage.setItem(RELOAD_KEY, "1");
      } catch {
        alreadyReloaded = true;
      }
      if (!alreadyReloaded) {
        window.location.reload();
        // Never resolves; the page is reloading.
        return new Promise<{ default: T }>(() => {});
      }
      throw error;
    }
  });
}
